import styled from 'styled-components';

export const Container = styled.div`
   position: absolute;
    top: -45px;
    left: 0px;
`;

export const BarContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 2px 2px;
  border-radius: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: fit-content;
`;

export const IconButton = styled.button`
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    border-radius: 30px;
    background-color: #917bf7;  /* 40576d12 grey shade*/
  }

  &:hover .hover-icon g {
    stroke: #fff;
  }

  .hover-icon g {
    stroke: #917bf7;
    transition: background-color .1s linear,border-color .1s linear,color .1s linear;
  }

  .hover-icon:hover g {
    stroke: #fff;
  }
  
  .hover-icon{
    color: #917bf7;
  }

  &:hover .hover-icon {
    color: #fff;
    transition: background-color .1s linear,border-color .1s linear,color .1s linear;
  }

  .close-icon {
    font-size: 12px;
    color: #000;
    &:hover {
      color: #fff;
    }
  }
`;

export const BarPopupWrapper = styled.div`
  font-family: Open Sans;
  max-width: 225px;
  .label {
    font-size: 14px;
    color: #000;
  }
  .ant-switch {
    margin-right: 4px;
  }
  .ant-switch-checked {
    background: #917bf7 !important;
  }
`;

export const AccessibilityContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 150px;
  width: 100%;
  margin: auto;
  .summary-editor {
    .ql-container {
      border: 1px solid #333;
      border-radius: 6px;
      height: 150px;
      .ql-editor {
        overflow: auto !important;
      }
    }
  }
  .summary-editor-disabled {
    background: #f0f0f0 !important;
    cursor: not-allowed;
    .ql-container {
      border: 1px solid #b8b8b8;
    }
  }
  .summary-save-button {
    margin-top: 8px;
    width:${props => (props.isAltText ? '100%': '49%')};
    background: linear-gradient(135deg, #917bf7, #6c54e0);
    color: #fff;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    transition: background 0.2s ease;

    &:hover {
      background: linear-gradient(135deg, #7d65e8, #5a44c9);
    }

    svg{
     width: 16px !important;
     height: 16px !important;
    }
  }
  .summary-clear-button {
    margin-top: 8px;
    width: 49%;
    background: linear-gradient(135deg, #ff6b6b, #e53935);
    color: #fff;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    transition: background 0.2s ease;

    &:hover {
      background: linear-gradient(135deg, #e55c5c, #c62828);
    }

    svg{
     width: 16px !important;
     height: 16px !important;
    }
  }
  .summary-button-parent{
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between;
  }
`;

export const ValidationTitleText = styled.p`
  color: white;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 3px;
`;

export const LinkInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
`;

export const LinkActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 5px 10px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  white-space: nowrap;
  transition: background 0.2s ease, transform 0.1s ease;
`;

export const LinkSaveButton = styled(LinkActionButton)`
  background: linear-gradient(135deg, #917bf7, #6c54e0);
  color: #fff;

  &:hover {
    background: linear-gradient(135deg, #7d65e8, #5a44c9);
  }
`;

export const LinkCancelButton = styled(LinkActionButton)`
  background: #f0f0f0;
  color: #666;

  &:hover {
    background: #e0e0e0;
    color: #333;
  }
`;

export const LinkEditButton = styled(LinkActionButton)`
  flex: 1;
  background: linear-gradient(135deg, #917bf7, #6c54e0);
  color: #fff;

  &:hover {
    background: linear-gradient(135deg, #7d65e8, #5a44c9);
  }
`;

export const LinkRemoveButton = styled(LinkActionButton)`
  flex: 1;
  background: linear-gradient(135deg, #ff6b6b, #e53935);
  color: #fff;

  &:hover {
    background: linear-gradient(135deg, #e55c5c, #c62828);
  }
`;

export const LinkSavedContainer = styled.div`
  margin-top: 10px;
`;

export const LinkDisplayCard = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #f5f3ff, #ede9ff);
  border: 1px solid #d4c9fc;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;

  .link-icon {
    color: #917bf7;
    font-size: 14px;
    flex-shrink: 0;
  }
`;

export const LinkDisplayText = styled.span`
  color: #4a3a9e;
  font-size: 13px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
  display: block;
`;

export const LinkActionRow = styled.div`
  display: flex;
  gap: 6px;
`;

export const LinkErrorMessage = styled.p`
  margin: 6px 0 0;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #c0392b;
  background: #fdf0ef;
  border: 1px solid #f5c6c2;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
`;